import { createPromiseControllers } from '../../../common/v5/helpers';
import { clearInsertionText, insertText } from '../cke';
import { wrapProtectReplyContentMarker } from '../common';

const [
    insertionTextStart
    , insertionTextControl
] = createPromiseControllers();

const preserveBlankLineSpacing = root => {
    root.querySelectorAll('div, p').forEach(el => {
        if (el.querySelector('p, div, img, table, ul, ol, iframe, hr, input, video, audio, object, svg, button')) {
            return;
        }

        // A block is a blank line when it has no visible text of any whitespace
        // flavour (space, tab, nbsp, unicode/zero-width spaces). CKEditor 5 drops
        // such whitespace-only <div> blocks, so rebuild them as <p>&nbsp;</p>.
        const hasText = el.textContent
            .replace(/[\s\u00a0\u200b\u200c\u200d\u2028\u2029\ufeff]/g, '')
            !== '';
        if (hasText) {
            return;
        }

        const paragraph = document.createElement('p');
        paragraph.innerHTML = '&nbsp;';
        el.parentNode.replaceChild(paragraph, el);
    });
};

const stripInlineFontStyles = root => {
    root.querySelectorAll('[style]').forEach(el => {
        const style = el.getAttribute('style');
        if (!style) {
            return;
        }

        const remainingStyles = style
            .split(';')
            .map(part => part.trim())
            .filter(part => {
                const property = part.split(':')[0];
                if (!property) {
                    return false;
                }

                const normalizedProperty = property.trim().toLowerCase();
                return normalizedProperty !== 'font-family'
                    && normalizedProperty !== 'font-size';
            });

        if (remainingStyles.length) {
            el.setAttribute('style', remainingStyles.join('; '));
        } else {
            el.removeAttribute('style');
        }
    });

    root.querySelectorAll('font[face], font[size]').forEach(font => {
        font.removeAttribute('face');
        font.removeAttribute('size');
    });
};

export const prepareKnowledgeBaseHtml = html => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    preserveBlankLineSpacing(tempDiv);
    stripInlineFontStyles(tempDiv);

    return tempDiv.innerHTML;
};

export const insertContent = text => dispatch => {
    const p = insertionTextStart(true);

    if (typeof text === 'string' && text.indexOf('<') !== -1) {
        dispatch(insertText(prepareKnowledgeBaseHtml(text)));
    } else {
        dispatch(insertText(text));
    }
    return p;
};

export const insertProtectedReplyContent = text => (
	dispatch
	, getState
) => dispatch(insertContent(wrapProtectReplyContentMarker(text, getState())));

export const clearInsertionContent = () => dispatch => {
    dispatch(clearInsertionText());
    insertionTextControl();
};
